// extracted by mini-css-extract-plugin
module.exports = {"ShareIcons":"ShareIcons_ShareIcons__9AGxH","ShareIcon":"ShareIcons_ShareIcon__GcuJZ","is_hidden":"ShareIcons_is_hidden__Bw9xs","ShareBtn":"ShareIcons_ShareBtn__1Z_Vz"};